export const props = Object.freeze({
  /**
   * Caption rendered above the digits — typically describes what the countdown is for.
   *
   * @type {String}
   * @default "Days until event"
   */
  label: {
    type: String,
    default: "Days until event",
  },
  /**
   * Target date in Rails-style "YYYY-MM-DD HH:MM:SS +ZZZZ" format. The countdown ticks down to this moment and clamps at zero when reached. Invalid dates display zeros.
   *
   * @type {String}
   */
  date: {
    type: String,
    required: true,
  },
});
